import type { CredentialUser } from '@maideveloper/base';

const API_ENDPOINT = '/api/login';
const HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

export default async (username: string, password: string): Promise<CredentialUser> => {
  try {
    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify({
        username,
        password
      }),
    });

    if (!response.ok) {
      const result = (await response.json()) as StandardErrorResponse;
      const errorMessage = result.errors.map((error: StandardError) => error.message).join(', ');
      throw new Error(errorMessage);
    }

    return response.json() as Promise<CredentialUser>;
  } catch (error) {
    throw new Error(`Login failed: ${(error as Error).message}`);
  }
}
